import React, { useContext } from "react";
import "./breadcrumb-comp.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";

const Breadcrumb_comp = ({ data }) => {
  const { secondBreadCrum } = useContext(Context)
  const navigate = useNavigate();
  const handleSelect = (href) => {
    navigate(href);
  };

  return (
    <>
      <div className="container">
        <div className="Breadcrumb_comp">
          <Breadcrumb>
            <Breadcrumb.Item className="firstbread" href="/">
              Home <FontAwesomeIcon icon={faChevronRight} />{" "}
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item href="/media-spaces"> */}
            <Breadcrumb.Item
              onClick={() => {
                const path = secondBreadCrum === 'Find the Vendor & Location'
                  ? '/find-vendor'
                  : `/media-spaces/${data?.category?.id}`;
                handleSelect(path);
              }}
            >
              {/* {data?.category?.name} */}
              {secondBreadCrum}

              <FontAwesomeIcon icon={faChevronRight} />
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/studio-inner" active>
              {data?.name}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
    </>
  );
};

export default Breadcrumb_comp;
